var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from "react";
import { observer } from "mobx-react";
import { List, ListHeading, ListHeadingCount, ListItems, ListItemEmpty, } from "./components";
// import {GenericListBoardCollection, ListBoardPropsList, ListBoardPropsRender} from "./types";
import { ListBoardItem } from "./item";
import { FaQuestionCircle } from "react-icons/fa";
import { Tooltip } from "../tooltip";
let ListBoardList = class ListBoardList extends React.Component {
    render() {
        const { list, data, renderIcon, renderRow, renderRowDropdown } = this.props;
        if (list.hide)
            return null;
        let items = [];
        if (data.lists[list.id]) {
            items = data.lists[list.id].items;
        }
        if (list.hideIfEmpty && items.length === 0)
            return null;
        return (React.createElement(List, null,
            React.createElement(ListHeading, { color: list.color },
                React.createElement(ListHeadingCount, null, items.length),
                list.title,
                !!(list.tooltipContent && list.tooltipSize) && (React.createElement(Tooltip, { text: list.tooltipContent, width: list.tooltipSize, position: "top" },
                    React.createElement(FaQuestionCircle, null)))),
            React.createElement(ListItems, null,
                items.map((item, z) => (React.createElement(ListBoardItem, { key: z, list: list, item: item, renderIcon: renderIcon, renderRow: renderRow, renderRowDropdown: renderRowDropdown }))),
                items.length === 0 && (React.createElement(ListItemEmpty, null,
                    React.createElement("p", null, "Nothing here..."))))));
    }
};
ListBoardList = __decorate([
    observer
], ListBoardList);
export { ListBoardList };
//# sourceMappingURL=list.js.map